import { styled } from 'styled-components';

export interface GapWrapperProps {
  $direction?: 'row' | 'column';
  wrap?: boolean;
}

export const GapWrapper = styled.div<GapWrapperProps>`
  display: flex;
  gap: 4px;
  align-items: flex-start;
  flex-direction: ${({ $direction }) => $direction ?? 'row'};
  flex-wrap: ${({ wrap }) => (wrap ? 'wrap' : 'nowrap')};
`;
